import { EditorState } from 'prosemirror-state'

export const inLastChild = (state: EditorState) => state.selection.$anchor.node() === state.doc.lastChild
